import { Box, Tab, Tabs } from '@mui/material';
import { PageTitle } from '../../../components/StyledComponents';
import PowerBiEmbedded from '../../../components/PowerBIPublicEmbed/PowerBiEmbedded';
import { powerbiConfig } from '../../../config/powerbi';

interface DashboardsSectionProps {
  activeTab: number;
  onTabChange: (event: React.SyntheticEvent, newValue: number) => void;
}

const DashboardsSection = ({ activeTab, onTabChange }: DashboardsSectionProps) => {
  return (
    <Box sx={{ flex: '0 0 auto', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ p: 1, mb: 1 }}>
        <PageTitle>Financials</PageTitle>
      </Box>
      <Tabs
        value={activeTab}
        onChange={onTabChange}
        sx={{
          px: 2,
          minHeight: '40px',
          display: 'flex',
          justifyContent: 'flex-end',
          '& .MuiTabs-flexContainer': {
            justifyContent: 'flex-end',
          },
          '& .MuiTabs-indicator': {
            backgroundColor: '#1f4D83',
          },
          '& .MuiTab-root': {
            fontFamily: 'Arial',
            fontSize: '11pt',
            textTransform: 'none',
            minHeight: '40px',
            fontWeight: 400,
            color: 'text.primary',
            outline: 'none',
            '&:focus': {
              outline: 'none',
            },
            '&:focus-visible': {
              outline: 'none',
            },
          },
          '& .Mui-selected': {
            color: '#1f4D83 !important',
          },
        }}
      >
        <Tab label="GFEBS Financial Summary" />
        <Tab label="ITD Financial Summary" />
        <Tab label="ITD Financial Details" />
      </Tabs>
      <Box sx={{ width: '100%', height: '1px', bgcolor: 'divider', mb: 2 }} />
      <Box sx={{ width: '100%', px: 2 }}>
        {activeTab === 0 && (
          <Box
            sx={{
              width: '100%',
              aspectRatio: '1725/800',
              minHeight: '400px',
              position: 'relative',
              overflow: 'hidden',
              '& > div': { border: 'none' },
            }}
          >
            <PowerBiEmbedded
              reportId={powerbiConfig.dashboards.gfebsFinancialSummary.reportId}
              datasetId={powerbiConfig.dashboards.gfebsFinancialSummary.datasetId}
            />
          </Box>
        )}
        {activeTab === 1 && (
          <Box
            sx={{
              width: '100%',
              aspectRatio: '1725/800',
              minHeight: '400px',
              position: 'relative',
              overflow: 'hidden',
              '& > div': { border: 'none' },
            }}
          >
            <PowerBiEmbedded
              reportId={powerbiConfig.dashboards.itdFinancialSummary.reportId}
              datasetId={powerbiConfig.dashboards.itdFinancialSummary.datasetId}
            />
          </Box>
        )}
        {activeTab === 2 && (
          <Box
            sx={{
              width: '100%',
              aspectRatio: '1725/800',
              minHeight: '400px',
              position: 'relative',
              overflow: 'hidden',
              '& > div': { border: 'none' },
            }}
          >
            <PowerBiEmbedded
              reportId={powerbiConfig.dashboards.itdFinancialDetails.reportId}
              datasetId={powerbiConfig.dashboards.itdFinancialDetails.datasetId}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default DashboardsSection;
